/**
 * ConfirmationModal Component
 * Reusable modal for delete/destructive action confirmations
 */
import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface ConfirmationModalProps {
    show: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    variant?: 'danger' | 'warning' | 'primary';
    size?: 'sm' | 'md' | 'lg';
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
    /** Shown inline under the message, e.g. when the confirmed action failed. */
    error?: string | null;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    title = 'Bekräfta',
    message,
    confirmText = 'Ta bort',
    cancelText = 'Avbryt',
    variant = 'danger',
    size = 'sm',
    onConfirm,
    onCancel,
    loading = false,
    error = null,
}) => {
    return (
        <Modal show={show} onHide={onCancel} centered size={size === 'md' ? undefined : size}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">{message}</p>
                {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onCancel}
                    disabled={loading}
                >
                    {cancelText}
                </Button>
                <Button
                    variant={variant}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? 'Vänta...' : confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
